// extracted by mini-css-extract-plugin
export var chevron = "_28-2";
export var chevronCollapsed = "_28-3";
export var collapsibleHeader = "_28-1";
export var container = "_28-0";